import { createUseWishlist } from "@decocms/apps-vtex/hooks/createUseWishlist";
import { invoke } from "~/server/invoke";

export type { WishlistItem } from "@decocms/apps-vtex/loaders/wishlist";

export const { useWishlist, resetWishlist } = createUseWishlist({ invoke });
